import { createContext, useContext, useEffect, useState } from "react";
import { dianaApi } from "../../services";

const MediaContext = createContext();

export const MediaProvider = ({ children }) => {
  const [medias, setMedias] = useState([]);

  const filterMedia = (mediaId) => {
    const filteredMedia = medias.filter((value) => value.id === mediaId);
    return filteredMedia.length >= 1 ? filteredMedia[0].guid.rendered : "";
  };

  useEffect(() => {
    dianaApi
      .get(
        "https://diana.thapcom.com.br/wp-json/wp/v2/media?_embed&per_page=100"
      )
      .then((response) => setMedias(response.data));
  }, []);

  return (
    <MediaContext.Provider value={{ medias, filterMedia }}>
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = () => useContext(MediaContext);
